<div class="paginated-kpi">
    @for (v of values; track v) {
        <div class="card paginated-kpi__tile">
            <span>{{ v.titleKey | translate }}</span>
            <div>
                <span class="font-semibold text-4xl mr-2">{{ v.value }}</span>
                <span>{{ 'unit.' + v.unit | translate }}</span>
            </div>
        </div>
    }
</div>
